import accounting from 'accounting-js'
import store from "@/store";
export const Num = {
  // for UI, it returns string type
  percision: 100,
  price(number, exchange, round_number = 2) {
    let item_price = store.getters.exchange_price(number, exchange)
    return accounting.toFixed(item_price, round_number)
  },
  // for calculation part, it float type
  round(number, round_number = 2) {
    return parseFloat(accounting.toFixed(number, round_number))
  },
  isNumber(num) {
    return !isNaN(parseFloat(num)) && isFinite(num)
  },
  sub(no1, no2) {
    return (no1 * this.percision - no2 * this.percision) / this.percision
  },
  add() {
    let add = 0
    for (var i in arguments) {
      add += arguments[i] * this.percision
    }
    return add / this.percision
  },
}
